import { BaseRoutes } from '@monorepo/tools/src/lib/routes/base.routes';

export class DomainOverlapRoutes extends BaseRoutes {
	constructor() {
		super('domain-overlap');
	}
}
